"use client";

import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme, type Theme } from "@/hooks/use-theme";

type ThemeToggleProps = {
  className?: string;
  onToggled?: (next: Theme) => void;
};

export function ThemeToggle({ className, onToggled }: ThemeToggleProps) {
  const { theme, toggleTheme, mounted } = useTheme();

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={className}
      onClick={() => {
        const next: Theme = theme === "dark" ? "light" : "dark";
        toggleTheme();
        onToggled?.(next);
      }}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      {mounted ? (
        theme === "dark" ? (
          <Sun className="w-5 h-5 text-slate-400 hover:text-amber-400 transition-colors" />
        ) : (
          <Moon className="w-5 h-5 text-slate-600 hover:text-slate-800 transition-colors" />
        )
      ) : (
        <Moon className="w-5 h-5 text-slate-400" />
      )}
    </Button>
  );
}

/** Fixed top-right slot for shells that have no header (auth, onboarding). */
export function ThemeToggleCorner() {
  return (
    <div className="pointer-events-none fixed right-4 top-4 z-50">
      <div className="pointer-events-auto">
        <ThemeToggle />
      </div>
    </div>
  );
}
